import type { Set } from '@gonfalon/immutable-shim/immutableShim';

export function getTagsClause(tags: ArrayLike<string> | Set<string>) {
  if (tags) {
    const tagsArray = Array.from(tags);
    if (tagsArray.length > 0) {
      return `;${Array.from(tagsArray).join()}`;
    }
  }
  return '';
}
